// useTimeUpdate.js
import { useState, useEffect, useCallback } from "react";
import { toJewishDate, formatJewishDateInHebrew } from "jewish-date";

const useTimeUpdate = () => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [dayOfWeek, setDayOfWeek] = useState("");
  const [jewishDateInHebrewStr, setJewishDateInHebrewStr] = useState("");
  const [isShabbat, setIsShabbat] = useState(false);

  const checkIfShabbat = () => {
    const now = new Date();
    const currentDay = now.toLocaleDateString("he-IL", { weekday: "long" });
    const currentHour = now.getHours();
    return (currentDay === "יום שישי" && currentHour >= 16) ||
           (currentDay === "יום שבת" && currentHour < 20);
  };


  const updateTime = useCallback(() => {
    const date = new Date();
    setCurrentTime(date);
    setDayOfWeek(date.toLocaleDateString("he-IL", { weekday: "long" }));
    setJewishDateInHebrewStr(formatJewishDateInHebrew(toJewishDate(date)));
    setIsShabbat(checkIfShabbat());
  }, []);

  useEffect(() => {
    updateTime();
    const timeInterval = setInterval(updateTime, 30000);
    return () => clearInterval(timeInterval);
  }, [updateTime]);

  return { currentTime, dayOfWeek, jewishDateInHebrewStr, isShabbat };
};

export default useTimeUpdate;
